export default "__VITE_ASSET__BcWotylA__"